function requestUserJWT(userId, userEmail) {
  const url = '/auth-tools/jwt/issue';

  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user_id: userId,
      user_email: userEmail,
    }),
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => data.access_token)
    .catch(error => {
      console.error(`Error fetching JWT: ${error.message}`);
      throw error;
    });
}

export function getUserJWT(userId, userEmail) {
  if (!userId) {
    return Promise.reject(new Error('User ID not found'));
  }
  if (!userEmail) {
    return Promise.reject(new Error('User email not found'));
  }
  return requestUserJWT(userId, userEmail);
}

export function getUserRBAC(id) {
  const url = `/auth-tools/rbac/users/${id}`;
  return fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to get RBAC user id ${id} with error: ${error.message}`)); // eslint-disable-line no-console
}
export function postUserRBAC(id, role) {
  const obj = { user_ids: [id.toString()], role };
  const url = '/auth-tools/rbac/users';
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to add RBAC user id ${id} with error: ${error.message}`)); // eslint-disable-line no-console
}

export function updateUserRBAC(id, role) {
  const obj = { role };
  const url = `/auth-tools/rbac/users/${id}`;
  return fetch(url, {
    credentials: 'include',
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to update RBAC user id ${id} with error: ${error.message}`)); // eslint-disable-line no-console
}

export function deleteUserRBAC(id) {
  const url = `/auth-tools/rbac/users/${id}`;
  return fetch(url, {
    credentials: 'include',
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to delete RBAC user id ${id} with error: ${error.message}`)); // eslint-disable-line no-console
}

export function getAllUsersRBAC() {
  const url = '/auth-tools/rbac/users';
  return fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to get all RBAC users with error: ${error.message}`)); // eslint-disable-line no-console
}

export function getAdvertiserRBAC(pixel_source_name) {
  const url = `/auth-tools/rbac/advertisers/${pixel_source_name}`;
  return fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to get RBAC advertiser with error: ${error.message}`)); // eslint-disable-line no-console
}

export function getRolesInRBAC() {
  const url = '/auth-tools/rbac/roles';
  return fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to get RBAC roles with error: ${error.message}`)); // eslint-disable-line no-console
}

export function postRolesInRBAC(roles) {
  const obj = { custom_roles: roles };
  const url = '/auth-tools/rbac/roles';
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to POST RBAC roles ${roles.join(', ')} with error: ${error.message}`)); // eslint-disable-line no-console
}

export function putRoleInRBAC(role, newRole) {
  const obj = { new_role_name: newRole };
  const url = `/auth-tools/rbac/roles/${role}`;
  return fetch(url, {
    credentials: 'include',
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to PUT RBAC role ${role} with error: ${error.message}`)); // eslint-disable-line no-console
}

export function deleteRoleInRBAC(role) {
  const url = `/auth-tools/rbac/roles/${role}`;
  return fetch(url, {
    credentials: 'include',
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to DELETE RBAC role ${role} with error: ${error.message}`)); // eslint-disable-line no-console
}

export function getPermissionsForRoleInRBAC(role) {
  const url = `/auth-tools/rbac/roles/${role}/permissions`;
  return fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to get RBAC permissions for role ${role} with error: ${error.message}`)); // eslint-disable-line no-console
}

export function postPermissionsForRoleInRBAC(role, permissions) {
  const obj = { permissions };
  const url = `/auth-tools/rbac/roles/${role}/permissions`;
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to POST RBAC permissions for role ${role} with error: ${error.message}`)); // eslint-disable-line no-console
}

export function putPermissionsForRoleInRBAC(role, permissions) {
  const obj = { permissions };
  const url = `/auth-tools/rbac/roles/${role}/permissions`;
  return fetch(url, {
    credentials: 'include',
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to PUT RBAC permissions for role ${role} with error: ${error.message}`)); // eslint-disable-line no-console
}

export function deletePermissionsForRoleInRBAC(role) {
  const url = `/auth-tools/rbac/roles/${role}/permissions`;
  return fetch(url, {
    credentials: 'include',
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to DELETE RBAC permissions for role ${role} with error: ${error.message}`)); // eslint-disable-line no-console
}

export function getAllPermissionsInRBAC() {
  const url = '/auth-tools/rbac/permissions';
  return fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to get RBAC permissions with error: ${error.message}`)); // eslint-disable-line no-console
}

export function getUserAuthorizationActions(id) {
  const url = `/auth-tools/rbac/users/${id}/authorized-actions`;
  return fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.response)
    .catch(error => console.error(`Failed to get RBAC authorization actions for 
    user ${id} with error: ${error.message}`)); // eslint-disable-line no-console
}
